import { __exports as GetDurationUnitOptions } from "../../../../../_virtual/GetDurationUnitOptions.mjs";
import require$$0 from "../../../../../_virtual/index2.mjs";
var hasRequiredGetDurationUnitOptions;
function requireGetDurationUnitOptions() {
  if (hasRequiredGetDurationUnitOptions) return GetDurationUnitOptions;
  hasRequiredGetDurationUnitOptions = 1;
  Object.defineProperty(GetDurationUnitOptions, "__esModule", { value: true });
  GetDurationUnitOptions.GetDurationUnitOptions = void 0;
  var ecma402_abstract_1 = require$$0;
  function GetDurationUnitOptions$1(unit, options, baseStyle, stylesList, digitalBase, prevStyle) {
    var style = (0, ecma402_abstract_1.GetOption)(options, unit, "string", stylesList, void 0);
    var displayDefault = "always";
    if (style === void 0) {
      if (baseStyle === "digital") {
        if (unit !== "hours" && unit !== "minutes" && unit !== "seconds") {
          displayDefault = "auto";
        }
        style = digitalBase;
      } else {
        displayDefault = "auto";
        if (prevStyle === "numeric" || prevStyle === "2-digit") {
          style = "numeric";
        } else {
          style = baseStyle;
        }
      }
    }
    var displayField = "".concat(unit, "Display");
    var display = (0, ecma402_abstract_1.GetOption)(options, displayField, "string", ["always", "auto"], displayDefault);
    if (prevStyle === "numeric" || prevStyle === "2-digit") {
      if (style !== "numeric" && style !== "2-digit") {
        throw new RangeError("Can't mix numeric and non-numeric styles");
      } else if (unit === "minutes" || unit === "seconds") {
        style = "2-digit";
      }
      if (style === "numeric" && display === "always" && (unit === "milliseconds" || unit === "microseconds" || unit === "nanoseconds")) {
        throw new RangeError("Can't display milliseconds, microseconds, or nanoseconds in numeric format");
      }
    }
    return {
      style,
      display
    };
  }
  GetDurationUnitOptions.GetDurationUnitOptions = GetDurationUnitOptions$1;
  return GetDurationUnitOptions;
}
export {
  requireGetDurationUnitOptions as __require
};
